<script lang="ts">
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { Button, buttonVariants } from "$lib/components/ui/button/index.js";
  import { t } from "svelte-i18n";
  import { ScrollArea } from "$lib/components/ui/scroll-area/index.js";
  import { Files, PackagePlus } from "lucide-svelte";
  import * as Tooltip from "$lib/components/ui/tooltip/index.js";
  import { Input } from "$lib/components/ui/input";
  import { Search } from "lucide-svelte";
  import { Filter } from "lucide-svelte";
  import { Toggle } from "$lib/components/ui/toggle";
  import { searchFilterStore } from "$src/application/products/searchProductStore";
  import { fly } from "svelte/transition";

  let isOpen: boolean = false;
</script>

<Dialog.Root bind:open={isOpen}>
  <Dialog.Trigger>
    <Button
      variant="default"
      class="w-12 h-12 rounded-full p-1  transition-transform transform  hover:scale-110"
    >
      <PackagePlus />
    </Button>
  </Dialog.Trigger>
  <Dialog.Content
    class="flex flex-col h-dvh sm:h-[650px] sm:my-auto overflow-hidden sm:max-h-dvh max-w-4xl gap-2"
  >
    <Dialog.Header>
      <Dialog.Title>{$t("page.products.search.title")}</Dialog.Title>
    </Dialog.Header>

    <div class="flex flex-row gap-2">
      <Input />
      <Button>
        <Search class="mr-2 h-4 w-4" />
        {$t("global.messages.search")}
      </Button>
      <Toggle aria-label="toggle bold" bind:pressed={$searchFilterStore}>
        <Filter class="h-4 w-4" />
      </Toggle>
    </div>

    {#if $searchFilterStore}
      <div
        class="flex flex-row gap-2 bg-secondary rounded-md p-2"
        transition:fly={{ y: -20, duration: 300 }}
      >
        Filters
      </div>
    {/if}

    <div class="flex flex-col flex-grow h-full overflow-hidden">
      <ScrollArea orientation="vertical">
        <div class="grid w-full h-full grid-cols-2 gap-2 max-w-md p-2"></div>
      </ScrollArea>
    </div>
    <Dialog.Footer class="flex pt-4">
      <Button type="submit" class="px-8">
        {$t("global.messages.close")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
